import Container from "../utils/Container"
import SectionTitle from "../utils/SectionTitle"

const Links = () => {
  return (
    <section id="links">
      <Container>
        <SectionTitle title="Presse">
        </SectionTitle>
        <a href="https://www.lefigaro.fr/economie/maitre-victoire-gibert-avocate-penaliste-la-nouvelle-generation-du-barreau-de-paris-20260507">
          <p>Maître Victoire Gibert, avocate pénaliste : la nouvelle génération du barreau de Paris<br></br></p>
          <b>Le Figaro</b>
        </a>

        <br></br>
        <br></br>


        <a href="https://leparisien.fr/hauts-de-seine-92/jetais-a-bout-trois-surveillants-de-la-prison-de-nanterre-juges-pour-des-achats-darrets-maladie-sur-snapchat-01-04-2026-URM7LXEUJNG3PIPF6BDBWWOMOY.php?at_medium=Social%2520media%26at_campaign%3DPartage%2520Natif%2520Apps">
          <p>« J’étais à bout » : trois surveillants de la prison de Nanterre jugés pour des achats d’arrêts maladie sur Snapchat<br></br></p>
          <b>Le Parisien</b>
        </a>

        <br></br>
        <br></br>

        <a href="https://www.ici.fr/normandie/manche-50/cherbourg-en-cotentin/au-tribunal-de-cherbourg-proces-renvoye-pour-six-prevenus-impliques-dans-un-trafic-de-drogue-8452597">
          <p>Au tribunal de Cherbourg, procès renvoyé pour six prévenus impliqués dans un trafic de drogue <br></br></p>
          <b>Ici-Normandie</b>
        </a>


      </Container>
    </section>
  )
}

export default Links
